import React, { useEffect, useRef } from 'react'

function useFocusOutside(
  ref: React.RefObject<HTMLElement>,
  callback: (e: FocusEvent) => void,
  enabled: boolean,
) {
  const enabledRef = useRef<Boolean>(enabled)
  const callbackRef = useRef<any>(null)
  callbackRef.current = callback
  enabledRef.current = enabled

  useEffect(() => {
    function handleFocus(e) {
      if (enabledRef.current && !ref.current?.contains(e.target)) {
        callbackRef.current(e)
      }
    }

    if (enabled) {
      window.addEventListener('click', handleFocus)

      return () => {
        window.removeEventListener('click', handleFocus)
      }
    }
  }, [ref, enabled])
}

export default useFocusOutside
